function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs30"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: -28.029,
  x2: -27.588,
  y1: -24.549,
  y2: -24.549
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop10",
  stopColor: "#e5e5e6",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop12",
  stopColor: "#fff",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: -585.8,
  x2: -584.3,
  y1: -352.5,
  y2: -352.5
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop15",
  stopColor: "#e5e5e6",
  offset: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop17",
  stopColor: "#fff",
  offset: 0.86
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: -2233.2,
  x2: -2167.6,
  y1: 2424.3,
  y2: 2424.3,
  gradientTransform: "translate(-170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: -12762,
  x2: -12724,
  y1: -3043.3,
  y2: -3043.3,
  gradientTransform: "matrix(.99996 0 0 1 -170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: -2135.5,
  x2: -2069.9,
  y1: 2424.3,
  y2: 2424.3,
  gradientTransform: "translate(-170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: -13033,
  x2: -12995,
  y1: -3239.5,
  y2: -3239.5,
  gradientTransform: "matrix(.99998 0 0 1 -170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: -3198.6,
  x2: -3132.8,
  y1: 636.97,
  y2: 636.97,
  gradientTransform: "translate(-170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: -13026,
  x2: -12989,
  y1: -3435.1,
  y2: -3435.1,
  gradientTransform: "matrix(.99998 0 0 1 -170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: -3024.3,
  x2: -2958.7,
  y1: 476.26,
  y2: 476.26,
  gradientTransform: "translate(-170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: -11954,
  x2: -11917,
  y1: -2456.9,
  y2: -2456.9,
  gradientTransform: "matrix(.99996 0 0 1 -170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: -3102.1,
  x2: -3036.4,
  y1: 535.31,
  y2: 535.31,
  gradientTransform: "translate(-170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  x1: -12224,
  x2: -12187,
  y1: -2652.4,
  y2: -2652.4,
  gradientTransform: "matrix(.99998 0 0 1 -170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient288",
  x1: -3179.8,
  x2: -3114.2,
  y1: 594.22,
  y2: 594.22,
  gradientTransform: "translate(-170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient290",
  x1: -13565,
  x2: -13527,
  y1: -4275.2,
  y2: -4275.2,
  gradientTransform: "matrix(.99999 0 0 1 -170.54 -4216)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "g32",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect32",
  width: 1566,
  height: 541
}), /*#__PURE__*/React.createElement("line", {
  id: "line34",
  x1: 221.82,
  x2: 1336.3,
  y1: 317.89,
  y2: 320.8,
  stroke: "#bcbec0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  id: "line36",
  x1: 893.95,
  x2: 893.95,
  y1: 153.84,
  y2: 310.78,
  stroke: "#bcbec0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "path38",
  d: "m848.98 164.09a74.386 74.386 0 1 1 104.22-14.287 74.383 74.383 0 0 1-104.22 14.287z",
  fill: "url(#linearGradient288)",
  fillRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "i3_4",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path40",
  d: "m936.68 48.531a70.685 70.685 0 1 1-99.034 13.576 70.764 70.764 0 0 1 99.034-13.576zm-78.205 103.05a58.684 58.684 0 1 0-11.268-82.223 58.751 58.751 0 0 0 11.268 82.223z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g650"
}, /*#__PURE__*/React.createElement("path", {
  id: "path42",
  d: "m909.45 78.463 18.629 0.016a0.692 0.692 0 0 1 0.693 0.691v45.711a0.693 0.693 0 0 1-0.693 0.693h-68.254a0.693 0.693 0 0 1-0.693-0.693v-45.77a0.69 0.69 0 0 1 0.693-0.691l18.629 0.018c0.375 0 30.621 0.025 31 0.025m17.744 1.359-66.677-0.017v44.385h66.871v-44.329"
}), /*#__PURE__*/React.createElement("path", {
  id: "path44",
  d: "m929.55 134.01h-71.192a4.914 4.914 0 0 1-4.91-4.908v-3.018a1.89 1.89 0 0 1 1.887-1.89h77.238a1.89 1.89 0 0 1 1.887 1.89v3.018a4.913 4.913 0 0 1-4.91 4.908zm-74.215-8.432a0.5 0.5 0 0 0-0.5 0.506v3.018a3.525 3.525 0 0 0 3.523 3.523h71.192a3.528 3.528 0 0 0 3.525-3.523v-3.018a0.5 0.5 0 0 0-0.5-0.506z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path46",
  d: "m893.95 132.2a3.107 3.107 0 1 1 3.11-3.107 3.111 3.111 0 0 1-3.11 3.107zm0-4.83a1.722 1.722 0 1 0 1.725 1.723 1.724 1.724 0 0 0-1.725-1.723z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path48",
  d: "m877.37 109.52a0.321 0.321 0 0 1-0.156-0.041 0.335 0.335 0 0 1-0.147-0.19l-2.129-7.959a0.314 0.314 0 0 1 0.223-0.383l3.27-0.877a0.323 0.323 0 0 1 0.238 0.034 0.312 0.312 0 0 1 0.144 0.189l2.131 7.957a0.312 0.312 0 0 1-0.22 0.383l-3.272 0.873a0.234 0.234 0 0 1-0.082 0.014zm-1.744-8.051 1.965 7.355 2.668-0.715-1.971-7.351z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path50",
  d: "m897.12 108.28h-0.015l-16.684-0.422a0.307 0.307 0 0 1-0.293-0.23l-1.711-6.4a0.309 0.309 0 0 1 0.137-0.349l14.236-8.7a0.309 0.309 0 0 1 0.471 0.295 25.043 25.043 0 0 0 4.066 15.257 0.311 0.311 0 0 1-0.207 0.545zm-16.451-1.039 15.838 0.4a26.052 26.052 0 0 1-3.916-14.606l-13.512 8.264z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path52",
  d: "m901.81 111.53c-3.021 0-6.562-4.7-8.232-10.935-1.857-6.926-0.822-13.02 2.359-13.873a2.8 2.8 0 0 1 0.745-0.1c3.027 0 6.566 4.7 8.23 10.936 1.861 6.925 0.824 13.019-2.354 13.875a2.917 2.917 0 0 1-0.748 0.097zm-5.128-24.281a2.169 2.169 0 0 0-0.579 0.076c-2.75 0.737-3.63 6.738-1.921 13.106 1.576 5.875 4.925 10.474 7.628 10.474a2.181 2.181 0 0 0 0.588-0.076c2.744-0.736 3.621-6.74 1.91-13.107-1.568-5.873-4.916-10.473-7.626-10.473z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path54",
  d: "m903.94 110.46a0.284 0.284 0 0 1-0.109-0.022c-2.762-1.017-5.586-5.32-7.033-10.707s-1.145-10.527 0.738-12.795a0.32 0.32 0 0 1 0.348-0.091c2.759 1.015 5.586 5.322 7.029 10.713s1.15 10.531-0.734 12.789a0.312 0.312 0 0 1-0.239 0.113zm-6.06-22.945c-1.608 2.183-1.809 7.078-0.473 12.054s3.953 9.116 6.43 10.2c1.609-2.173 1.808-7.066 0.472-12.048s-3.95-9.126-6.429-10.206z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path56",
  d: "m897.52 101.39a0.305 0.305 0 0 1-0.3-0.219c-0.168-0.527-0.309-1-0.426-1.436-0.127-0.464-0.237-0.941-0.348-1.455a0.313 0.313 0 0 1 0.178-0.347 7.072 7.072 0 0 1 1.154-0.414 7.214 7.214 0 0 1 1.82-0.254c1.254 0 2.116 0.414 2.3 1.1a1.68 1.68 0 0 1-0.789 1.658 6.357 6.357 0 0 1-2.357 1.141 8.085 8.085 0 0 1-1.209 0.221zm-0.4-2.991c0.09 0.413 0.184 0.8 0.289 1.174s0.207 0.743 0.338 1.164a7.909 7.909 0 0 0 0.856-0.173 5.741 5.741 0 0 0 2.119-1.018c0.443-0.367 0.658-0.734 0.582-1.012-0.106-0.387-0.787-0.644-1.7-0.644a6.508 6.508 0 0 0-1.664 0.234 6.193 6.193 0 0 0-0.824 0.277z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path58",
  d: "m888.42 118.89a0.315 0.315 0 0 1-0.274-0.162l-6.054-10.977a0.314 0.314 0 0 1 0.01-0.318 0.328 0.328 0 0 1 0.278-0.147l3.715 0.188a0.311 0.311 0 0 1 0.257 0.158l5.3 9.529a0.3 0.3 0 0 1 0.022 0.254 0.309 0.309 0 0 1-0.17 0.186l-2.963 1.263a0.286 0.286 0 0 1-0.12 0.026zm-5.51-10.949 5.645 10.238 2.382-1.018-5.048-9.072z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path60",
  d: "m882.24 103.95a0.313 0.313 0 0 1-0.08-0.615l9.8-2.629a0.317 0.317 0 0 1 0.381 0.223 0.313 0.313 0 0 1-0.223 0.383l-9.791 2.626a0.257 0.257 0 0 1-0.087 0.012z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path62",
  d: "m908.64 96.141a0.313 0.313 0 0 1-0.084-0.614l3.238-0.865a0.312 0.312 0 1 1 0.16 0.6l-3.234 0.867a0.53 0.53 0 0 1-0.08 0.012z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path64",
  d: "m912.66 100.12h-3.344a0.313 0.313 0 0 1 0-0.625h3.344a0.313 0.313 0 1 1 0 0.625z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path66",
  d: "m912.16 104.99a0.326 0.326 0 0 1-0.076-0.01l-3.231-0.867a0.312 0.312 0 1 1 0.161-0.6l3.228 0.865a0.313 0.313 0 0 1 0.223 0.383 0.31 0.31 0 0 1-0.305 0.229z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path68",
  d: "m904.41 89.371a0.318 0.318 0 0 1-0.221-0.094 0.313 0.313 0 0 1 0-0.441l2.368-2.365a0.312 0.312 0 0 1 0.443 0 0.317 0.317 0 0 1 0 0.441l-2.367 2.365a0.319 0.319 0 0 1-0.223 0.094z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path70",
  d: "m906.97 92.477a0.313 0.313 0 0 1-0.157-0.584l2.9-1.67a0.31139 0.31139 0 0 1 0.312 0.539l-2.9 1.674a0.3 0.3 0 0 1-0.155 0.041z"
})));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "path72",
  d: "m913.03 304.57a22.666 22.666 0 1 0-6.846 31.316 22.67 22.67 0 0 0 6.846-31.316z",
  fill: "#2d250c",
  fillRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "path74",
  d: "m904.45 310.07a12.476 12.476 0 1 0-3.769 17.236 12.477 12.477 0 0 0 3.769-17.236z",
  fill: "url(#linearGradient290)",
  fillRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("text", {
  id: "text82",
  x: 893.95099,
  y: 452.487,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "18px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan76",
  x: 859.90399,
  y: 452.487
}, "Seadista"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan80",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan78",
  x: 853.896,
  y: 474.08701
}, "teavitused")));

var _ref9 = /*#__PURE__*/React.createElement("text", {
  id: "text86",
  x: 874.63098,
  y: 422.78201,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "48px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan84",
  x: 874.63098,
  y: 422.78201
}, "4."));

var _ref10 = /*#__PURE__*/React.createElement("line", {
  id: "line88",
  x1: 1115.1,
  x2: 1115.1,
  y1: 143.36,
  y2: 300.31,
  fill: "none",
  stroke: "#bcbec0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "path90",
  d: "m1115.1 30.451a74.386 74.386 0 1 1-74.385 74.388 74.384 74.384 0 0 1 74.385-74.388z",
  fill: "url(#c)",
  fillRule: "evenodd"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "i3_5"
}, /*#__PURE__*/React.createElement("path", {
  id: "path92",
  d: "m1115.1 175.52a70.684 70.684 0 1 1 70.681-70.682 70.762 70.762 0 0 1-70.681 70.682zm0-129.37a58.684 58.684 0 1 0 58.681 58.686 58.75 58.75 0 0 0-58.681-58.686z",
  fill: "#5d752e"
}), /*#__PURE__*/React.createElement("g", {
  id: "g679",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path94",
  d: "m1108.3 110.06a0.7 0.7 0 0 1-0.349-0.095l-16.162-9.328a0.7 0.7 0 0 1-0.326-0.426 0.7 0.7 0 0 1 0.07-0.533l12.129-20.993a0.7 0.7 0 0 1 0.957-0.259l16.166 9.331a0.7 0.7 0 0 1 0.254 0.957l-12.133 20.995a0.7 0.7 0 0 1-0.606 0.351zm-15.205-10.287 14.95 8.629 11.433-19.783-14.955-8.624z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path96",
  d: "m1121.5 89.418a2.423 2.423 0 0 1-1.194-0.318l-16.617-9.585a2.4 2.4 0 0 1-0.877-3.266 0.463 0.463 0 0 1 0.045-0.064 2.391 2.391 0 0 1 3.227-0.811l16.617 9.584a2.4 2.4 0 0 1 0.873 3.269 2.4 2.4 0 0 1-2.074 1.191zm-17.493-12.432a0.992 0.992 0 0 0 0.383 1.314l16.615 9.587a0.992 0.992 0 1 0 0.995-1.716l-16.616-9.584a0.991 0.991 0 0 0-1.353 0.361s-0.016 0.024-0.024 0.038z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path98",
  d: "m1107.7 113.34a2.381 2.381 0 0 1-1.191-0.319l-16.615-9.584a2.4 2.4 0 0 1-0.877-3.267 2.409 2.409 0 0 1 2.076-1.192 2.382 2.382 0 0 1 1.191 0.321l16.616 9.584a2.387 2.387 0 0 1-1.2 4.457zm-16.607-12.961a1 1 0 0 0-0.863 0.492 0.971 0.971 0 0 0-0.1 0.752 0.981 0.981 0 0 0 0.461 0.6l16.613 9.585a1 1 0 0 0 1.358-0.359 0.994 0.994 0 0 0-0.366-1.354l-16.613-9.584a0.978 0.978 0 0 0-0.49-0.132z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path100",
  d: "m1114.9 107.52a0.7 0.7 0 0 1-0.359-0.1l-3.807-2.279a0.7 0.7 0 0 1-0.246-0.952l6.563-11.359a0.706 0.706 0 0 1 0.429-0.326 0.688 0.688 0 0 1 0.535 0.076l3.807 2.271a0.7 0.7 0 0 1 0.248 0.953l-6.562 11.364a0.711 0.711 0 0 1-0.434 0.328 0.674 0.674 0 0 1-0.174 0.024zm-2.857-3.224 2.6 1.558 5.864-10.151-2.6-1.554z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path102",
  d: "m1151.5 124.87a4.353 4.353 0 0 1-2.279-0.641l-32.776-20.118a0.7 0.7 0 0 1-0.24-0.946l2.816-4.88a0.7 0.7 0 0 1 0.94-0.265l33.83 18.307a4.375 4.375 0 0 1 2.127 2.693 4.6 4.6 0 0 1-4.418 5.85zm-33.742-21.6 32.195 19.762a2.946 2.946 0 0 0 1.547 0.434 3.2 3.2 0 0 0 3.072-4.071 2.986 2.986 0 0 0-1.451-1.842l-33.226-17.98z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path104",
  d: "m1151.3 122.53a2.4 2.4 0 0 1 0-4.8 2.408 2.408 0 0 1 1.2 0.321 2.375 2.375 0 0 1 1.121 1.455 2.4 2.4 0 0 1-2.318 3.019zm0-3.394a1 1 0 0 0-0.969 1.256 0.991 0.991 0 0 0 0.467 0.6 0.981 0.981 0 0 0 0.5 0.136 1 1 0 0 0 0.865-0.5 0.972 0.972 0 0 0 0.1-0.754 1 1 0 0 0-0.963-0.74z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path106",
  d: "m1111 122.54h-30.871a0.7 0.7 0 0 1-0.7-0.7v-2.814a3.515 3.515 0 0 1 3.512-3.51h25.246a3.513 3.513 0 0 1 3.512 3.51v2.814a0.7 0.7 0 0 1-0.699 0.7zm-30.17-1.4h29.469v-2.114a2.112 2.112 0 0 0-2.112-2.109h-25.246a2.112 2.112 0 0 0-2.111 2.109z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path108",
  d: "m1116.3 128.16h-41.367a0.7 0.7 0 0 1-0.7-0.7v-5.625a0.7 0.7 0 0 1 0.7-0.7h41.367a0.7 0.7 0 0 1 0.7 0.7v5.625a0.7 0.7 0 0 1-0.7 0.7zm-40.666-1.4h39.965v-4.224h-39.969z"
})));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "path110",
  d: "m1128.5 298.46a22.668 22.668 0 1 0 5.014 31.661 22.671 22.671 0 0 0-5.014-31.661z",
  fill: "#5d752e",
  fillRule: "evenodd"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "path112",
  d: "m1122.5 306.71a12.475 12.475 0 1 0 2.759 17.426 12.48 12.48 0 0 0-2.759-17.426z",
  fill: "url(#d)",
  fillRule: "evenodd"
});

var _ref15 = /*#__PURE__*/React.createElement("text", {
  id: "text122",
  x: 1115.139,
  y: 452.487,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "18px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan114",
  x: 1092.05,
  y: 452.487
}, "Osale"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan120",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan116",
  x: 1048.103,
  y: 474.08701
}, "enampakkumistel"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan118",
  x: 1073.703,
  y: 495.68701
}, "ja hangetel")));

var _ref16 = /*#__PURE__*/React.createElement("text", {
  id: "text126",
  x: 1100.84,
  y: 422.78201,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "48px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan124",
  x: 1100.84,
  y: 422.78201
}, "5."));

var _ref17 = /*#__PURE__*/React.createElement("line", {
  id: "line128",
  x1: 1336.3,
  x2: 1336.3,
  y1: 153.84,
  y2: 310.78,
  fill: "none",
  stroke: "#bcbec0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "path130",
  d: "m1336.3 30.451a74.386 74.386 0 1 1-74.385 74.388 74.385 74.385 0 0 1 74.385-74.388z",
  fill: "url(#e)",
  fillRule: "evenodd"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "i3_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "path132",
  d: "m1336.3 175.52a70.684 70.684 0 1 1 70.682-70.682 70.763 70.763 0 0 1-70.682 70.682zm0-129.37a58.684 58.684 0 1 0 58.682 58.686 58.751 58.751 0 0 0-58.682-58.686z",
  fill: "#f4c478"
}), /*#__PURE__*/React.createElement("g", {
  id: "g705",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path134",
  d: "m1336.3 136.52a0.607 0.607 0 0 1-0.568-0.393l-13.129-34.632a0.59 0.59 0 0 1 0.01-0.448l6.15-14.817a0.612 0.612 0 0 1 0.563-0.375h13.951a0.611 0.611 0 0 1 0.562 0.375l6.151 14.817a0.586 0.586 0 0 1 0.01 0.448l-13.127 34.632a0.606 0.606 0 0 1-0.568 0.393zm-12.476-35.23 12.476 32.909 12.475-32.909-5.9-14.22h-13.14z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path136",
  d: "m1362.3 101.89h-52.026a0.608 0.608 0 0 1-0.5-0.946l9.933-14.814a0.606 0.606 0 0 1 0.506-0.272h32.154a0.6 0.6 0 0 1 0.506 0.272l9.934 14.814a0.607 0.607 0 0 1-0.5 0.946zm-50.885-1.215h49.748l-9.121-13.6h-31.506z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path138",
  d: "m1336.3 136.52a0.6 0.6 0 0 1-0.486-0.243l-26.014-34.632a0.608 0.608 0 0 1 0.486-0.973h52.026a0.607 0.607 0 0 1 0.486 0.973l-26.013 34.632a0.6 0.6 0 0 1-0.485 0.243zm-24.8-34.633 24.8 33.013 24.8-33.013z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path140",
  d: "m1336.3 136.52a0.608 0.608 0 0 1-0.609-0.607v-49.45a0.609 0.609 0 0 1 1.217 0v49.45a0.609 0.609 0 0 1-0.608 0.607z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path142",
  d: "m1331.1 82.815a0.624 0.624 0 0 1-0.357-0.115 0.612 0.612 0 0 1-0.219-0.681l1.867-5.7-4.863-3.515a0.606 0.606 0 0 1-0.221-0.679 0.612 0.612 0 0 1 0.578-0.421l6 0.01 1.844-5.71a0.611 0.611 0 0 1 0.578-0.421 0.6 0.6 0 0 1 0.576 0.421l1.846 5.71 6-0.01a0.608 0.608 0 0 1 0.355 1.1l-4.861 3.515 1.867 5.7a0.607 0.607 0 0 1-0.935 0.679l-4.852-3.535-4.851 3.535a0.614 0.614 0 0 1-0.352 0.117zm5.211-5.011a0.616 0.616 0 0 1 0.358 0.115l3.689 2.69-1.42-4.338a0.61 0.61 0 0 1 0.221-0.682l3.695-2.67-4.562 0.01a0.606 0.606 0 0 1-0.578-0.421l-1.4-4.341-1.4 4.341a0.616 0.616 0 0 1-0.582 0.421l-4.563-0.01 3.694 2.67a0.608 0.608 0 0 1 0.22 0.682l-1.42 4.338 3.692-2.688a0.6 0.6 0 0 1 0.356-0.121z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path144",
  d: "m1355.9 82.969a0.6 0.6 0 0 1-0.326-0.1 0.612 0.612 0 0 1-0.185-0.841l2.345-3.659a0.60721 0.60721 0 1 1 1.022 0.656l-2.342 3.66a0.613 0.613 0 0 1-0.514 0.284z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path146",
  d: "m1359.5 86.92a0.609 0.609 0 0 1-0.282-1.149l3.864-2a0.608 0.608 0 0 1 0.558 1.08l-3.859 2a0.631 0.631 0 0 1-0.281 0.069z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path148",
  d: "m1350.8 81.354h-0.028a0.606 0.606 0 0 1-0.578-0.634l0.2-4.348a0.60712 0.60712 0 1 1 1.213 0.055l-0.2 4.347a0.606 0.606 0 0 1-0.607 0.58z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path150",
  d: "m1316.7 82.969a0.61 0.61 0 0 1-0.512-0.279l-2.343-3.667a0.60736 0.60736 0 0 1 1.023-0.655l2.344 3.665a0.607 0.607 0 0 1-0.512 0.936z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path152",
  d: "m1313.1 86.92a0.6 0.6 0 0 1-0.278-0.069l-3.863-2a0.60805 0.60805 0 0 1 0.559-1.08l3.863 2a0.609 0.609 0 0 1-0.281 1.149z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path154",
  d: "m1321.9 81.35a0.61 0.61 0 0 1-0.608-0.581l-0.195-4.342a0.60812 0.60812 0 1 1 1.215-0.055l0.193 4.343a0.6 0.6 0 0 1-0.578 0.634z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path156",
  d: "m1356.6 136.63h-40.648a0.607 0.607 0 1 1 0-1.214h40.648a0.607 0.607 0 1 1 0 1.214z"
})));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "path158",
  d: "m1349.6 298.46a22.667 22.667 0 1 0 5.015 31.661 22.669 22.669 0 0 0-5.015-31.661z",
  fill: "#f4c478",
  fillRule: "evenodd"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "path160",
  d: "m1343.7 306.71a12.476 12.476 0 1 0 2.758 17.426 12.478 12.478 0 0 0-2.758-17.426z",
  fill: "url(#f)",
  fillRule: "evenodd"
});

var _ref22 = /*#__PURE__*/React.createElement("text", {
  id: "text170",
  x: 1336.328,
  y: 452.487,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "18px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan162",
  x: 1313.095,
  y: 452.487
}, "V\xF5ida"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan168",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan164",
  x: 1273.89,
  y: 474.08701
}, "enampakkumisi/"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan166",
  x: 1306.403,
  y: 495.68701
}, "hankeid")));

var _ref23 = /*#__PURE__*/React.createElement("text", {
  id: "text174",
  x: 1317.0081,
  y: 422.78201,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "48px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan172",
  x: 1317.0081,
  y: 422.78201
}, "6."));

var _ref24 = /*#__PURE__*/React.createElement("line", {
  id: "line176",
  x1: 230.39,
  x2: 230.39,
  y1: 142.08,
  y2: 299.03,
  fill: "none",
  stroke: "#bcbec0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  id: "path178",
  d: "m172.64 151.73a74.385 74.385 0 1 1 104.63 10.855 74.383 74.383 0 0 1-104.63-10.855z",
  fill: "url(#g)",
  fillRule: "evenodd"
});

var _ref26 = /*#__PURE__*/React.createElement("g", {
  id: "i3_1",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path180",
  d: "m285.26 60.281a70.684 70.684 0 1 1-99.424-10.315 70.762 70.762 0 0 1 99.424 10.315zm-100.43 81.547a58.684 58.684 0 1 0 8.57-82.547 58.754 58.754 0 0 0-8.572 82.547z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g540"
}, /*#__PURE__*/React.createElement("path", {
  id: "path182",
  d: "m226.68 102.06a17.85 17.85 0 1 0-17.866-17.854 17.88 17.88 0 0 0 17.866 17.854zm0-34.05a16.2 16.2 0 1 1-16.217 16.2 16.223 16.223 0 0 1 16.217-16.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path184",
  d: "m247.86 107.99a14.582 14.582 0 0 0-9.918 3.9 32.731 32.731 0 0 0-11.261-1.963 30.489 30.489 0 0 0-19.485 6.609c-5.832 4.827-8.916 11.705-8.916 19.891a0.826 0.826 0 0 0 0.825 0.824h47.667l-5e-3 -0.055c0.361 0.026 0.724 0.055 1.093 0.055a14.629 14.629 0 1 0 0-29.258zm-47.92 27.609c0.44-16.5 14.065-24.026 26.741-24.026a31.55 31.55 0 0 1 10 1.622 14.588 14.588 0 0 0 4.457 22.4zm55.9-11.206h-5.967v6.42h-4.062v-6.42h-5.936v-3.579h5.936v-6.386h4.062v6.386h5.967z"
})));

var _ref27 = /*#__PURE__*/React.createElement("path", {
  id: "path186",
  d: "m249.47 304.57a22.667 22.667 0 1 0-6.846 31.316 22.671 22.671 0 0 0 6.846-31.316z",
  fill: "#2d250c",
  fillRule: "evenodd"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  id: "path188",
  d: "m240.89 310.07a12.476 12.476 0 1 0-3.77 17.236 12.478 12.478 0 0 0 3.77-17.236z",
  fill: "url(#h)",
  fillRule: "evenodd"
});

var _ref29 = /*#__PURE__*/React.createElement("text", {
  id: "text196",
  x: 230.38901,
  y: 452.487,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "18px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan190",
  x: 212.258,
  y: 452.487
}, "Liitu"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan194",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan192",
  x: 181.271,
  y: 474.08701
}, "keskkonnaga")));

var _ref30 = /*#__PURE__*/React.createElement("text", {
  id: "text200",
  x: 211.069,
  y: 422.78201,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "48px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan198",
  x: 211.069,
  y: 422.78201
}, "1."));

var _ref31 = /*#__PURE__*/React.createElement("line", {
  id: "line202",
  x1: 451.58,
  x2: 451.58,
  y1: 153.84,
  y2: 310.78,
  fill: "none",
  stroke: "#bcbec0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  id: "path204",
  d: "m406.61 164.09a74.386 74.386 0 1 1 104.22-14.293 74.385 74.385 0 0 1-104.22 14.293z",
  fill: "url(#i)",
  fillRule: "evenodd"
});

var _ref33 = /*#__PURE__*/React.createElement("g", {
  id: "i3_2"
}, /*#__PURE__*/React.createElement("g", {
  id: "i234234"
}, /*#__PURE__*/React.createElement("g", {
  id: "i3_2324"
}, /*#__PURE__*/React.createElement("path", {
  id: "path206",
  d: "m494.31 48.532a70.685 70.685 0 1 1-99.034 13.575 70.759 70.759 0 0 1 99.034-13.575zm-78.209 103.05a58.685 58.685 0 1 0-11.264-82.223 58.754 58.754 0 0 0 11.264 82.223z",
  fill: "#5d752e"
}))), /*#__PURE__*/React.createElement("g", {
  id: "g610"
}, /*#__PURE__*/React.createElement("g", {
  id: "g136",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path208",
  d: "m451.58 95.4a3.973 3.973 0 1 1 3.971-3.974 3.979 3.979 0 0 1-3.971 3.974zm0-6.6a2.624 2.624 0 1 0 2.621 2.623 2.625 2.625 0 0 0-2.621-2.618z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path210",
  d: "m459.01 105.36h-14.866a0.674 0.674 0 0 1-0.673-0.677 7.318 7.318 0 0 1 2.56-5.8 8.957 8.957 0 0 1 11.088 0 7.308 7.308 0 0 1 2.563 5.73v0.071a0.675 0.675 0 0 1-0.672 0.676zm-14.16-1.351h13.453c-0.342-3.908-3.647-5.7-6.727-5.7s-6.387 1.794-6.726 5.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path212",
  d: "m462.9 120.84h-22.634a0.675 0.675 0 0 1 0-1.35h22.638a0.675 0.675 0 0 1 0 1.35z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path214",
  d: "m462.9 112.35h-22.634a0.675 0.675 0 0 1 0-1.35h22.638a0.675 0.675 0 0 1 0 1.35z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path216",
  d: "m470.48 143.6h-37.808a4.2 4.2 0 0 1-4.193-4.2v-7.787a0.673 0.673 0 0 1 0.673-0.676h44.852a0.673 0.673 0 0 1 0.672 0.676v7.787a4.2 4.2 0 0 1-4.196 4.2zm-40.652-11.31v7.112a2.849 2.849 0 0 0 2.844 2.848h37.808a2.847 2.847 0 0 0 2.846-2.848v-7.112z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path218",
  d: "m474 77.359h-44.852a0.674 0.674 0 0 1-0.673-0.676v-7.795a4.2 4.2 0 0 1 4.193-4.191h37.808a4.2 4.2 0 0 1 4.2 4.191v7.795a0.674 0.674 0 0 1-0.676 0.676zm-44.176-1.352h43.5v-7.119a2.845 2.845 0 0 0-2.846-2.841h-37.81a2.846 2.846 0 0 0-2.844 2.841z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path220",
  d: "m451.58 140.57a3.25 3.25 0 1 1 3.25-3.251 3.256 3.256 0 0 1-3.25 3.251zm0-5.15a1.9 1.9 0 1 0 1.9 1.9 1.9 1.9 0 0 0-1.9-1.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path222",
  d: "m456.07 71.8h-8.992a0.675 0.675 0 1 1 0-1.35h8.992a0.675 0.675 0 1 1 0 1.35z"
})), /*#__PURE__*/React.createElement("g", {
  id: "g588"
}, /*#__PURE__*/React.createElement("g", {
  id: "g583"
}, /*#__PURE__*/React.createElement("g", {
  id: "g570"
}, /*#__PURE__*/React.createElement("path", {
  id: "path224",
  d: "m470.48 143.6h-37.808a4.2 4.2 0 0 1-4.193-4.2v-70.518a4.2 4.2 0 0 1 4.193-4.191h37.808a4.2 4.2 0 0 1 4.2 4.191v70.518a4.2 4.2 0 0 1-4.2 4.2zm-37.808-77.557a2.846 2.846 0 0 0-2.844 2.841v70.518a2.849 2.849 0 0 0 2.844 2.848h37.808a2.847 2.847 0 0 0 2.846-2.848v-70.518a2.845 2.845 0 0 0-2.846-2.841z",
  fill: "#2d250c"
}))))));

var _ref34 = /*#__PURE__*/React.createElement("path", {
  id: "path226",
  d: "m464.9 298.46a22.667 22.667 0 1 0 5.014 31.661 22.671 22.671 0 0 0-5.014-31.661z",
  fill: "#5d752e",
  fillRule: "evenodd"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  id: "path228",
  d: "m458.91 306.71a12.475 12.475 0 1 0 2.76 17.426 12.48 12.48 0 0 0-2.76-17.426z",
  fill: "url(#j)",
  fillRule: "evenodd"
});

var _ref36 = /*#__PURE__*/React.createElement("text", {
  id: "text236",
  x: 451.57599,
  y: 452.487,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "18px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan230",
  x: 401.25699,
  y: 452.487
}, "T\xE4ienda oma"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan234",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan232",
  x: 418.604,
  y: 474.08701
}, "andmeid")));

var _ref37 = /*#__PURE__*/React.createElement("text", {
  id: "text240",
  x: 432.25699,
  y: 422.78201,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "48px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan238",
  x: 432.25699,
  y: 422.78201
}, "2."));

var _ref38 = /*#__PURE__*/React.createElement("line", {
  id: "line242",
  x1: 672.77,
  x2: 672.77,
  y1: 153.84,
  y2: 310.78,
  fill: "none",
  stroke: "#bcbec0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  id: "path244",
  d: "m627.79 164.09a74.386 74.386 0 1 1 104.22-14.292 74.384 74.384 0 0 1-104.22 14.292z",
  fill: "url(#k)",
  fillRule: "evenodd"
});

var _ref40 = /*#__PURE__*/React.createElement("g", {
  id: "i3_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "path246",
  d: "m715.49 48.531a70.684 70.684 0 1 1-99.032 13.576 70.764 70.764 0 0 1 99.032-13.576zm-78.207 103.05a58.685 58.685 0 1 0-11.267-82.223 58.755 58.755 0 0 0 11.267 82.223z",
  fill: "#f4c478"
}), /*#__PURE__*/React.createElement("g", {
  id: "g622",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path248",
  d: "m696.28 77.953h-47.037a0.677 0.677 0 0 1-0.676-0.676v-11.32a0.676 0.676 0 0 1 0.676-0.678h47.037a0.676 0.676 0 0 1 0.676 0.678v11.32a0.677 0.677 0 0 1-0.676 0.676zm-46.359-1.353h45.681v-9.969h-45.681z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path250",
  d: "m676.7 72.289h-7.879a0.677 0.677 0 0 1 0-1.353h7.879a0.677 0.677 0 1 1 0 1.353z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path252",
  d: "m696.28 144.4h-47.037a0.677 0.677 0 0 1-0.676-0.676v-77.762a0.676 0.676 0 0 1 0.676-0.678h47.037a0.676 0.676 0 0 1 0.676 0.678v77.762a0.677 0.677 0 0 1-0.676 0.676zm-46.359-1.354h45.681v-76.41h-45.681z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path254",
  d: "m672.76 115.76a17.182 17.182 0 1 1 17.2-17.182 17.209 17.209 0 0 1-17.2 17.182zm0-33.01a15.828 15.828 0 1 0 15.839 15.828 15.852 15.852 0 0 0-15.839-15.828z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path256",
  d: "m672.76 115.76a17.206 17.206 0 0 1-11.118-4.078 0.677 0.677 0 0 1-0.214-0.7 10.053 10.053 0 0 1 4.451-5.92 13.439 13.439 0 0 1 7.072-1.941c5.561 0 10.059 2.971 11.461 7.565a0.677 0.677 0 0 1-0.2 0.7 17.183 17.183 0 0 1-11.452 4.374zm-9.9-4.832a15.844 15.844 0 0 0 20.121-0.256c-1.63-4.563-6.377-6.193-10.027-6.193-3.733 0-8.546 1.699-10.094 6.449z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path258",
  d: "m672.97 99.254a5.131 5.131 0 1 1 5.133-5.131 5.14 5.14 0 0 1-5.133 5.131zm0-8.908a3.777 3.777 0 1 0 3.779 3.777 3.783 3.783 0 0 0-3.779-3.777z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path260",
  d: "m672.76 118.17a10.585 10.585 0 1 0 10.584 10.584 10.585 10.585 0 0 0-10.584-10.584zm6.918 5.756-9.272 11.207a0.514 0.514 0 0 1-0.162 0.137l-0.119 0.052a1.067 1.067 0 0 1-0.367 0.1h-0.078a1.118 1.118 0 0 1-0.493-0.123l-0.218-0.127a1 1 0 0 1-0.184-0.207l-0.068-0.086-2.985-5.17a1.127 1.127 0 0 1 0.412-1.535 1.156 1.156 0 0 1 1.537 0.412l2.161 3.748 8.1-9.836a1.158 1.158 0 0 1 1.58-0.156 1.12 1.12 0 0 1 0.155 1.584z"
})));

var _ref41 = /*#__PURE__*/React.createElement("path", {
  id: "path262",
  d: "m686.09 298.46a22.668 22.668 0 1 0 5.014 31.661 22.671 22.671 0 0 0-5.014-31.661z",
  fill: "#f4c478",
  fillRule: "evenodd"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  id: "path264",
  d: "m680.1 306.71a12.475 12.475 0 1 0 2.757 17.426 12.477 12.477 0 0 0-2.757-17.426z",
  fill: "url(#l)",
  fillRule: "evenodd"
});

var _ref43 = /*#__PURE__*/React.createElement("text", {
  id: "text272",
  x: 672.76501,
  y: 452.487,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "18px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan266",
  x: 624.09302,
  y: 452.487
}, "Moderaator"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan270",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan268",
  x: 609.25201,
  y: 474.08701
}, "kinnitab andmed")));

var _ref44 = /*#__PURE__*/React.createElement("text", {
  id: "text276",
  x: 653.44501,
  y: 422.78201,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "48px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan274",
  x: 653.44501,
  y: 422.78201
}, "3."));

var SvgIllustration33 = function SvgIllustration33(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg282",
    width: 1566,
    height: 541,
    viewBox: "0 0 1566 541",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllustration33, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/illustration3_3.cbd9ba20.svg";
export { ForwardRef as ReactComponent };